import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {TranslationService} from "../../../../../core/services/translation.service";
import {AddressSearch} from "../../../../../data/models/address-search.model";
import {AddressSearchService} from "../../../../../core/services/address-search.service";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from "@angular/material/autocomplete";
import {AddressFieldHandler, AddressFormularField} from "./address-field-handler";


@Component({
  selector: 'app-hup-subscription-address-specifics',
  templateUrl: './hup-subscription-address-specifics.component.html',
  styleUrls: ['./hup-subscription-address-specifics.component.css'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatOption,
    MatLabel,
    MatError,
    MatHint
],
  standalone: true
})
export class HupSubscriptionAddressSpecificsComponent {
  translationService = inject(TranslationService);
  private addressSearchService = inject(AddressSearchService);

  @Input() controlGroup: FormGroup;
  @Input() streetNames: string[];
  @Input() isAustriaSelected: boolean;
  @Output() searchAddressEmit: EventEmitter<any> = new EventEmitter();
  @Input() addressFieldHandler?: AddressFieldHandler;

  addressSearch: AddressSearch = new AddressSearch(null, null, null, null, null, null);
  replaceInvalidCharactersFromHouseNo() {
    var value = this.controlGroup.get('address.houseNo').value.toUpperCase();
    if(value.length > 10) value = value.slice(0, 10);
    this.controlGroup.get('address.houseNo').setValue(value.replace(/[^A-Za-z0-9\-\/]*/g, ''), {emitEvent: false});
  }

  isRequired(fieldName: AddressFormularField) {
    return this.addressFieldHandler.isRequired(fieldName);
  }

  protected readonly document = typeof document === 'object' ? document : null;
  protected readonly AddressFormularField = AddressFormularField;
}
